import React from "react";
import { motion } from "framer-motion";
import { Check, AlertTriangle, XCircle } from "lucide-react";

const ITEMS = [
    {
        tag: "🟢 Boa escolha",
        title: "Liberado",
        desc: "Combina com suas restrições e com o seu objetivo. Pode ir no carrinho sem dor de cabeça.",
        color: "#16A34A",
        icon: Check,
        bg: "bg-[#16A34A]/8",
        border: "border-[#16A34A]/15",
    },
    {
        tag: "🟡 Com moderação",
        title: "Atenção",
        desc: "Alguns pontos exigem cuidado. Ideal para consumo ocasional, mas não no dia a dia.",
        color: "#F59E0B",
        icon: AlertTriangle,
        bg: "bg-[#F59E0B]/8",
        border: "border-[#F59E0B]/20",
    },
    {
        tag: "🔴 Melhor evitar",
        title: "Evite",
        desc: "Contém algo incompatível com seu perfil ou vai na contramão da sua meta. O Dentro te avisa.",
        color: "#DC2626",
        icon: XCircle,
        bg: "bg-[#DC2626]/8",
        border: "border-[#DC2626]/20",
    },
];

export default function Problema() {
    return (
        <section
            id="problema"
            data-testid="problema-section"
            className="relative py-20 md:py-28"
        >
            <div className="max-w-7xl mx-auto px-6 lg:px-8">
                <motion.div
                    initial={{ opacity: 0, y: 24 }}
                    whileInView={{ opacity: 1, y: 0 }}
                    viewport={{ once: true, margin: "-80px" }}
                    transition={{ duration: 0.6 }}
                    className="max-w-3xl"
                >
                    <span className="text-xs uppercase tracking-[0.2em] font-bold text-[#16A34A]">
                        O problema
                    </span>
                    <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl font-extrabold text-[#0B1C3A] tracking-tight">
                        Rótulos são difíceis. Sua escolha não precisa ser.
                    </h2>
                    <p className="mt-5 text-lg text-[#475569] leading-relaxed">
                        Açúcar escondido, sódio em excesso, aditivos, alergênicos
                        e ingredientes técnicos transformam qualquer escolha do
                        supermercado em um quebra-cabeça. O Dentro resolve isso
                        por você em um sistema simples:
                    </p>
                </motion.div>

                <div className="mt-14 grid md:grid-cols-3 gap-5">
                    {ITEMS.map((it, i) => {
                        const Icon = it.icon;
                        return (
                            <motion.div
                                key={it.title}
                                initial={{ opacity: 0, y: 24 }}
                                whileInView={{ opacity: 1, y: 0 }}
                                viewport={{ once: true, margin: "-80px" }}
                                transition={{ duration: 0.55, delay: i * 0.08 }}
                                data-testid={`problema-card-${it.title.toLowerCase()}`}
                                className={`relative rounded-3xl border ${it.border} ${it.bg} p-7`}
                            >
                                <div
                                    className="h-12 w-12 rounded-2xl grid place-items-center text-white"
                                    style={{ background: it.color }}
                                >
                                    <Icon size={22} strokeWidth={2.5} />
                                </div>
                                <div
                                    className="mt-5 text-xs uppercase tracking-[0.18em] font-extrabold"
                                    style={{ color: it.color }}
                                >
                                    {it.tag}
                                </div>
                                <h3 className="mt-1 font-display text-2xl font-extrabold text-[#0B1C3A]">
                                    {it.title}
                                </h3>
                                <p className="mt-2 text-[15px] text-[#475569] leading-relaxed">
                                    {it.desc}
                                </p>
                            </motion.div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
